import React from 'react';
import {Typography} from "@mui/joy";
import {Box} from "@mui/material";
import {useTranslation} from "react-i18next";
import AssetProductImage from "../AssetProductImage";
import {KeyValueInformation} from "../AssetNameplate";
import {CatalogProductNode} from "@dreebit-registry/vsm-microservice-components";

interface Props {
    product: CatalogProductNode;
}

/**
 * Compact nameplate for a catalog product — same layout as the compact
 * AssetNameplate (image left, title + key/value rows right), but purely
 * presentational: the product comes in as a prop, no queries. Shown above the
 * create-asset form when a product was picked from the catalog. No serial
 * row: the asset doesn't exist yet, the serial is entered in the form below.
 */
const ProductNameplate = ({product}: Props) => {
    const {t} = useTranslation();

    return (
        <Box display={"flex"} alignItems={"center"}>
            <Box alignSelf="center">
                <AssetProductImage src={product.image?.thumbnailLink ?? undefined} style={{height: 85, width: 85}}/>
            </Box>

            <Box flexGrow={1} sx={{pl: 3}}>
                <Typography level={"titleMedium"} fontWeight={"bold"}>
                    {product.name}
                </Typography>
                <Box>
                    <KeyValueInformation title={t('Product code')} value={product.productCode ?? undefined}/>
                    <KeyValueInformation title={t('Manufacturer')} value={product.manufacturer?.name ?? undefined}/>
                </Box>
            </Box>
        </Box>
    );
};

export default ProductNameplate;
